<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
  created() {
    document.documentElement.style.setProperty('--scale-factor', (200 / Math.round(window.devicePixelRatio * 100) * 0.2))
  }
}
</script>
<style>
:root {
  --scale-factor: 0.2;
  --position-x: 0;
  --position-y: 0;
  --position-scale: cover;
}

* {
  box-sizing: border-box;
}

body,
html {
  padding: 0;
  margin: 0;
  height: 100%;
}

#app {
  font-family: var(--link-font-family, -apple-system, BlinkMacSystemFont, "Segoe UI",
    "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "Helvetica Neue", Arial, sans-serif);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: var(--link-ink, #292524);
  height: 100%;
}
</style>
